exports.default = {
  'recent_use': '最近使用',
  'search': '搜尋智能助理',
  'search_not_found': '找不到與{ value }相關的結果',
  'more_result': '更多關於{ value }搜索的結果 >'
}
